import { FC } from 'react';
import { Button } from 'common-components';
import { useTranslationContext } from '../contexts/translationContext';
import { Switch, TextField } from '../uiLibraryImports';
import Tabs from '../tabs';
import Search from '../search';
import ShareItem from '../shareItem';
import { ShareProps } from './shareType';
import styles from './share.module.scss';

const Share: FC<ShareProps> = (props: ShareProps) => {
    const {
        onShareClick,
        setCurrentTabId,
        onSelectAll,
        selectOption,
        onCancel,
        setSearchValue,
        addNote,
        setAddNote,
        setNote,
        note,
        filteredOptions,
        currentTabId,
        searchValue,
        selectedOptions,
        currentType
    } = props;
    const { translate } = useTranslationContext();

    return (
        <div className={styles.wrapper}>
            <div className={styles.header}>
                <div className={styles.tabs}>
                    <Tabs
                        title={translate('ShareWith')}
                        tabs={[
                            { id: 1, title: translate('Users'), count: selectedOptions.users.length },
                            { id: 2, title: translate('Teams'), count: selectedOptions.teams.length }
                        ]}
                        currentTabId={currentTabId}
                        onTabClick={setCurrentTabId}
                    />
                </div>
                <Search value={searchValue} onChange={(value: string) => setSearchValue(value)} />
                <div className={styles['select-all']} onClick={() => onSelectAll()}>
                    {translate('SelectAll')}
                </div>
            </div>
            <div className={styles.list}>
                {filteredOptions.map(option => (
                    <div key={option.id} className={styles.option}>
                        <ShareItem
                            onSelect={() => selectOption(option.id)}
                            profilePicture={option?.icon}
                            nickname={option.displayName}
                            isSelected={selectedOptions[currentType].includes(option.id)}
                        />
                    </div>
                ))}
            </div>
            <div>
                <div className={styles['note-wrapper']}>
                    <div className={styles['add-note']}>
                        <div>{translate('AddPersonalNote')}</div>
                        <Switch checked={addNote} onChange={() => setAddNote((prev: boolean) => !prev)} />
                    </div>
                    {addNote && (
                        <TextField
                            inputProps={{ 'data-testid': 'note' }}
                            value={note}
                            onChange={e => setNote(e.target.value)}
                            className={styles.note}
                            InputProps={{
                                className: styles.text,
                                disableUnderline: true
                            }}
                        />
                    )}
                </div>
                <div className={styles.divider} />
                <div className={styles.buttons}>
                    <Button
                        lowerCase
                        type="textFlat"
                        text={translate('Cancel')}
                        className={styles.cancel}
                        onClick={onCancel}
                    />
                    <div>
                        <Button lowerCase type="gradient" text={translate('Share')} onClick={onShareClick} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Share;
